<template>
	<div>
		<div v-if="newUser.newUser">
			<pagetitle>Nieuwe Medewerker</pagetitle>
			<div class="row bg-white">
				<div class="col-12 pt-3 pb-3">
 					<a href="#" class="btn btn-party btn-danger" @click="cancelCreateNewUser()">Annuleer</a>
					
					<form class="mt-5 mb-5">
						<div 
							class="form-group" v-for="(key, index) in userKeys"
							v-if="hasProp(newUser, key)"
						>
							<label :for="'input_'+key">{{ userKeysName[key] }} <span v-if="userKeysRequired.includes(key)">*</span></label>
							<select class="form-control" :class="{'btn-danger': errors.includes(key)}" :id="'input_'+key" v-model="newUser[key].value" v-if="key == 'role'">
								<option value="">-- Kies een rol --</option>
								<option :value="role.id" v-for="(role, index) in roles" :key="role.id">{{role.name  }}</option>
							</select>

							<input type="date" class="form-control" :class="{'btn-danger': errors.includes(key)}" :id="'input_'+key" v-model="newUser[key].value" 
								v-else-if="key == 'member_since' || key == 'date_of_birth'" />

							<input type="email" class="form-control" :class="{'btn-danger': errors.includes(key)}" :id="'input_'+key" v-model="newUser[key].value" v-else-if="key == 'email'" />
							<input type="text" class="form-control" :class="{'btn-danger': errors.includes(key)}" :id="'input_'+key" v-model="newUser[key].value" v-else>
						</div>
					</form>

					<a href="#" class="btn btn-block btn-theme " @click="storeCreateNewUser()">Opslaan</a>
				</div>
			</div>
		</div>
		<div v-else>
			<pagetitle>Alle Medewerkers</pagetitle>
			<div class="row bg-white">
				<div class="col-12">
					<table class="table">
						<thead>
							<tr>
								<th scope="col" width="20%">Foto</th>
								<th scope="col">Voornaam</th>
								<th scope="col">Achternaam</th>
								<th scope="col"></th>
							</tr>
							<tr>
								<th scope="col" width="20%"></th>
								<th scope="col"><input type="text" v-model="search.firstname" placeholder="voornaam" class="form-control"></th>
								<th scope="col"><input type="text" v-model="search.lastname" placeholder="achternaam" class="form-control"></th>
								<th scope="col"><a href="#" @click="createNewUser()" class="btn btn-theme" v-if="checkUserHasPermission('create user')">Nieuw</a></th>
							</tr>
						</thead>
						<tbody>

							<tr v-for="(user, index) in usersresult" :key="index">
									<td>
										<a 	:href="'/profile/'+user.id">
											<img class="w-100" :src="user.profile_image" :alt="user.firstname + ' '+ user.lastname">
										</a>
									</td>
									<td><a :href="'/profile/'+user.id" v-html="user.firstname"></a></td>
									<td><a :href="'/profile/'+user.id" v-html="user.lastname"></a></td>
									<td><a :href="'/profile/'+user.id" class="btn btn-theme">Open</a></td>
							</tr>
						</tbody>
					</table>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

	name: 'all-users',

	
	data () {
		return {
			users 	: [],
			search 	: {},
			user 	: {},
			errors  : [],
			roles   : [],
			newUser : {
				'newUser' : false,
			},
			userKeys: ['firstname', 'lastname', 'address', 'zipcode', 'city', 'country', 'mobile', 'phone', 'date_of_birth', 'member_since', 'email', 'role'],
			userKeysName : {
				'last_login' : 'Laatste keer ingelogd',
				'firstname' : 'Voornaam',
				'lastname' : 'Achternaam',
				'address' : 'Adres',
				'zipcode' : 'Postcode',
				'city' : 'Plaats',
				'country' : 'Land',
				'phone' : 'Telefoonnummer',
				'mobile' : 'Mobiel',
				'website' : 'Website',
				'function' : 'Functie',
				'profile_image' : 'Afbeelding',
				'date_of_birth' : 'Geboortedatum',
				'member_since' : 'Werkzaam sinds',
				'member_end' : 'Werkzaam tot',
				'about_me' : 'Over mij',
				'email' : 'Emailadres',
				'branches': 'Vestigingen',
				'role': 'Rol',
			},
			userKeysRequired : ['firstname', 'lastname', 'email', 'role']
		}
	},
	computed:{
		usersresult : function(){
			if(this.search.firstname && this.search.lastname){
				let search = this.search;
				let users = [];
				if(this.search.firstname.toLowerCase().length > 0 && this.search.lastname.toLowerCase().length >0){
					this.users.forEach(function(user) {
						if(user.firstname.toLowerCase().includes(search.firstname.toLowerCase()) && user.lastname.toLowerCase().includes(search.lastname.toLowerCase())){
							users.push(user);
						}

					});
					return users;
				}
			}

			// search users with firstname contain
			if(this.search.firstname){
				let search = this.search;
				let users = [];
				
				if(this.search.firstname.toLowerCase().length > 0){
					this.users.forEach(function(user) {
						if(user.firstname.toLowerCase().includes(search.firstname.toLowerCase())){
							users.push(user);
						}
					});
					return users;
				}
			}

			// search users with lastname contain
			if(this.search.lastname){
				let users = [];
				let search = this.search;
				if(this.search.lastname.toLowerCase().length > 0){
					this.users.forEach(function(user) {
						if(user.lastname.toLowerCase().includes(search.lastname.toLowerCase())){
							users.push(user);
						}
					});
					return users;
				}
			}
			return this.users;
		},
		
	},
	methods:{
		createNewUser : function(){
			let thas = this;

			this.userKeys.forEach(function(key) {
				if(!thas.hasProp(thas.newUser, key)){
					if(key == 'member_since'){
						thas.newUser[key] = {
							'value' : thas.getToday(),
							'error' : false,
						};
						console.log(new Date().toLocaleDateString());
						console.log(thas.getToday());
					}else{
						thas.newUser[key] = {
							'value' : '',
							'error' : false,
						};
					}
				}
			});

			this.newUser.newUser = true;
		},
		cancelCreateNewUser : function(){
			this.newUser.newUser = false;
		},
		storeCreateNewUser : function(){
			let thas = this;
			let error = false;

			this.errors = [];
			this.userKeys.forEach(function(key) {
				thas.newUser[key].error = false;
				if(thas.userKeysRequired.includes(key)){
					if(thas.hasProp(thas.newUser, key)){
						if(thas.newUser[key].value.length == 0 ){
							if(!error){
								error = key;
							}
							thas.newUser[key].error = true;
							thas.errors.push(key);
						}
					}else{
						thas.newUser[key].error = true;
						thas.errors.push(key);
						if(!error){
							error = key;
						}
					}
				}
			});
			if(error){
				alert('error: ' + error);
			}else{
				console.log('opslaan!', this.newUser);
				this.$store.dispatch("post", {endpoint:this.$store.state.endpoint+'users?token='+this.$store.state.token,details:this.newUser})
				.then(data=>{
					if(data.data.code == "-1"){
						this.showErrormessage(data.data.msg);
					}else{
						this.newUser.newUser = false;
						
						this.showErrormessage('Nieuwe gebruiker aangemaakt');

	                	this.$store.dispatch("get",this.$store.state.endpoint+'users?token='+this.$store.state.token)
					    .then(data=>{  
					        this.users=data.data.data;
					        window.console.log('data',data.data.data); 
					       
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					        // window.console.log(error.request.response);
					    });
					}
            	})
            	.catch(error=>{
					console.log(error.request);
            		this.showErrormessage(error);
            	});
			}
		},
		checkUserKey : function(key){
			return this.userKeys.includes(key);
		}
	},
	created(){
	    this.$store.dispatch("get",this.$store.state.endpoint+'users?token='+this.$store.state.token)
	    .then(data=>{  
	        this.users=data.data.data;
	        window.console.log('data',data.data.data); 
	       
	    }) 
	    .catch(error=>{
	        if(error.request.status == 401){
	            this.error=true;
	            this.error_msg="invalid login details";
	        }
	        // window.console.log(error.request.response);
	    });


	    this.$store.dispatch("get",this.$store.state.endpoint+'roles?token='+this.$store.state.token)
	    .then(data=>{  
	        this.roles = data.data.data;
	        window.console.log('data',data.data.data); 
	       
	    }) 
	    .catch(error=>{
	        if(error.request.status == 401){
	            this.error=true;
	            this.error_msg="invalid login details";
	        }
	        // window.console.log(error.request.response);
	    });


	}
		
	
}
</script>

<style lang="css" scoped>
</style>